/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemHeartWrapper_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"Heart_viewer">;
    readonly " $refType": "ItemHeartWrapper_viewer";
};
export type ItemHeartWrapper_viewer$data = ItemHeartWrapper_viewer;
export type ItemHeartWrapper_viewer$key = {
    readonly " $data"?: ItemHeartWrapper_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemHeartWrapper_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ItemHeartWrapper_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "loadPortfolioData",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String]",
      "defaultValue": []
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Heart_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "loadPortfolioData",
          "variableName": "loadPortfolioData"
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds"
        }
      ]
    }
  ]
};
(node as any).hash = 'abddb446fdad2128d9f357272503f7ea';
export default node;
